/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Pending_Action_TitleInputs */

const en_ticket_pending_action_title = /** @type {(inputs: Ticket_Pending_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing your action…`)
};

const ja_ticket_pending_action_title = /** @type {(inputs: Ticket_Pending_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクションを処理中…`)
};

const fr_ticket_pending_action_title = /** @type {(inputs: Ticket_Pending_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action en cours de traitement…`)
};

const de_ticket_pending_action_title = /** @type {(inputs: Ticket_Pending_Action_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion wird verarbeitet…`)
};

/**
* | output |
* | --- |
* | "Processing your action…" |
*
* @param {Ticket_Pending_Action_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_pending_action_title = /** @type {((inputs?: Ticket_Pending_Action_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Pending_Action_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_pending_action_title(inputs)
	if (locale === "ja") return ja_ticket_pending_action_title(inputs)
	if (locale === "fr") return fr_ticket_pending_action_title(inputs)
	return de_ticket_pending_action_title(inputs)
});